import { AsyncGettersAPI, Replicant } from '@play-co/replicant';
import { sharedStates } from 'src/replicant/sharedState';
import type { StateFromSchema } from '../../State';
import ab from '../../ruleset/ab';
import computedProperties from '../computedProperties';

// Helper for defining module async getters
const config = {
  ruleset: { abTests: ab.dynamicAB },
  computedProperties,
  sharedStates,
  state: {} as StateFromSchema,
} satisfies Replicant<any>;

export type SharedStatesAsyncGetterAPI = AsyncGettersAPI<
  Replicant<typeof config>
>;

export function getSharedStateAsyncGettersAPI(
  api: unknown,
): SharedStatesAsyncGetterAPI {
  return api as SharedStatesAsyncGetterAPI;
}
